module.exports = __webpack_public_path__ + "img/icon-arrow-up.626205d7.svg";